import * as React from "react"
import Box from "@mui/material/Box"
import AppBarComponent from "./components/app-bar-component"
import { Outlet, useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../app/store"
import ModalAlertComponent from "../../app/components/modal-alert-component"
import { checkUserAtLocalStorageAction } from "../signin/signin.slice"


export default function Dashboard() {
  const { alerts } = useAppSelector((state: RootState) => state.dashboard)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { currentUser, endSession, endSessionForce } = useAppSelector(
    (state: RootState) => state.login,
  )

  React.useEffect(() => {
    if ((currentUser === undefined && endSession) || endSessionForce === true) {
      navigate("/logout")
    }
  }, [currentUser, endSession, endSessionForce])

  React.useEffect(() => {
    dispatch(checkUserAtLocalStorageAction())
  }, [])

  return (
    <>
      <Box sx={{ display: "flex", width: "100%" }}>
        {alerts.map((el, i) => {
          return (
            <ModalAlertComponent
              key={"Alert999" + i}
              title={el.title}
              description={el.message}
              index={i}
              modalAlertState={el}
            />
          )
        })}
        {/* <CssBaseline /> */}
        {/* <DashboardContent /> */}
        <Box flexGrow={1}>
          <AppBarComponent/>
          <Box padding={2} paddingTop={10} maxWidth={"100vw"}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  )
}
